import React from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { MdLibraryAdd } from "react-icons/md";
import { apiPath, RoutePath } from "../../utility/Constant";
import { useState } from "react";
import { deleteData } from "../../hooks/delete";

const JobsCart = ({ job, user }) => {
  const [hidden, setHidden] = useState(false);
  const { addJobs } = RoutePath;
  const { jobsApi } = apiPath;
  const handleDelete = (event) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteData(`${jobsApi}/${event.target.id}`);
        setTimeout(() => {
          setHidden(true);
        }, 1000);
      }
    });
  };
  console.log(job);
  return (
    <div className={hidden && "hidden"}>
      {job ? (
        <div className="card bg-base-100 shadow-xl">
          <div className="p-3">
            <h2 className="text-md text-center uppercase font-semibold">
              {job.title}
            </h2>
            <div className="flex justify-center">
              <p className="btn btn-link text-gray-600">{job.exp}</p>
            </div>

            <div className="card-actions justify-between">
              <Link
                to={`/editJobs/${job._id}`}
                className="btn btn-outline btn-xs border-blue-500 text-blue-500 hover:bg-blue-500 hover:border-blue-500 hover:text-white"
              >
                Edit
              </Link>
              {user === "admin" && (
                <button
                  id={job._id}
                  onClick={handleDelete}
                  className="btn btn-outline btn-xs border-red-500 text-red-500 hover:bg-red-500 hover:border-red-500 hover:text-white"
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>
      ) : (
        <Link
          to={addJobs}
          className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full "
        >
          <p className="text-8xl">
            <MdLibraryAdd />
          </p>
        </Link>
      )}
    </div>
  );
};

export default JobsCart;
